import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

import { IGateAccountState } from '@/types/balance';

import { AppState } from '../store';
import { depositOrWithdrawBalance, setGateAccountState } from './actions';

export interface IBalanceState {
  chainGateAccountState: {
    [chainId: number]: IGateAccountState;
  };
}

const initialState: IBalanceState = {
  chainGateAccountState: {},
};

export const balanceSlice = createSlice({
  name: 'balance',
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    builder

      // .addCase(changeTokenGateBalanceAction.fulfilled, (state, action) => {
      //   const { arg } = action.meta;
      //   if (arg.token && arg.token.address) {
      //     const chainId = arg.chainId;
      //     const balanceInState = _.get(state.chainGateBalanceMap, [chainId, arg.userAddr, arg.token.address]);
      //     if (balanceInState) {
      //       // if the block height is lower than the current block height, we don't need to update the state
      //       if ((balanceInState?.block || 0) > (action.payload?.block || 0)) {
      //         return;
      //       }
      //     }
      //     _.set(
      //       state.chainGateBalanceMap,
      //       [chainId, arg.userAddr, arg.token.address],
      //       _.merge({}, balanceInState, {
      //         balance: ZERO,
      //         block: 0,
      //         ...action.payload,
      //         isLoading: false,
      //       }),
      //     );
      //   }
      // })

      .addCase(depositOrWithdrawBalance.pending, (state, { meta }) => {
        const { chainId } = meta.arg;
        _.set(state.chainGateAccountState, [chainId, 'isOperating'], true);
      })
      .addCase(depositOrWithdrawBalance.fulfilled, (state, { meta }) => {
        const { chainId } = meta.arg;
        _.set(state.chainGateAccountState, [chainId], {
          isOperating: false,
          depositAmountStr: '',
        });
      })
      .addCase(depositOrWithdrawBalance.rejected, (state, { meta }) => {
        const { chainId } = meta.arg;
        _.set(state.chainGateAccountState, [chainId, 'isOperating'], false);
      })
      .addCase(setGateAccountState, (state, { payload }) => {
        const currentState = _.get(state.chainGateAccountState, [payload.chainId]);
        _.set(state.chainGateAccountState, [payload.chainId], { ...currentState, ...payload });
      });
  },
});

export const { resetState } = balanceSlice.actions;

export const selectBalanceState = (state: AppState): IBalanceState => state.balance;

export const selectGateAccountState = (
  state: AppState,
): {
  [chainId: number]: IGateAccountState;
} => state.balance.chainGateAccountState;

export default balanceSlice.reducer;
